import { useCallback } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  useGetIdentity,
} from 'react-admin';
import { MarkdownField } from '@/components/MarkdownField';
import { BSON } from 'realm-web';

export const AppGlobalAlertsCreate = () => {
  const userId = useGetIdentity().data?.id?.toString();

  const transform = useCallback(
    (data: any) => {
      const now = new Date();

      console.log('data', data);

      const result = {
        ...data,
        createdBy: userId,
        createdAt: now,
        enabledAt: now,
        _id: new BSON.ObjectId(),
      };

      console.log('result', result);

      return result;
    },
    [userId],
  );

  return (
    <Create transform={transform}>
      <SimpleForm>
        <TextInput
          label="Title"
          source="title"
          validate={[required()]}
          fullWidth
        />
        <TextInput
          label="Single Line Description"
          source="singleLineDescription"
          validate={[required()]}
          fullWidth
        />
        <MarkdownField label="Alert Content" source="content" />
      </SimpleForm>
    </Create>
  );
};
